import React from "react";

import BetterflyLoading from "./betterfly/BetterflyLoading";
import HappLoading from "./happ/HappLoading";
import HanuLoading from "./HanuLoading";
import PropTypes from 'prop-types';

const PartnerLoadingSpinner = ({partner}) => {

    const LoadingElement = () => {
        switch (partner) {
            case 'betterfly':
                return <BetterflyLoading />;
            case 'happ':
                return <HappLoading />
            default:
                return <HanuLoading />;
        }
    };

    return <LoadingElement/>
}

PartnerLoadingSpinner.propTypes = {
    partner: PropTypes.string.isRequired
}

export default PartnerLoadingSpinner